import { reqList, reqDriverList, reqOrderDetail } from '@/api/reservation'
import dayjs from 'dayjs'
/* import { Loading } from 'element-ui' */

export default {
  async fetchList({ state, commit }) {
    /* const loading = Loading.service() */
    try {
      const params = {
        task: state.task,
        keyword: state.kw,
        sort: state.sort,
        sortStatus: state.sortStatus,
        searchTime: state.task === 'limitTime' ? 60 : '',
        rule: state.rule,
        currentStatus: state.currentStatus,
      }
      let pagingKey = 'teamPaging'
      if (state.activeTab === 'line') {
        pagingKey = 'linePaging'
      } else if (state.activeTab === 'airport') {
        pagingKey = 'airportPaging'
      }
      params.npp = state[pagingKey].npp
      params.page = state[pagingKey].currentPage
      const { result } = await reqList(params)
      commit('setLastUpdatedTime', dayjs().format('HH:mm:ss'))
      //console.log('reservation list', result)
      //commit('setReserveTotal', result.total)
      //commit('setNonReplyTotal', result.nonReplyTotal)
      //if (state.task === 'nonAssign') {
      //  commit('setNonAssignTotal', result.total)
      //}
      /* 設置專屬車隊或line網路預約的表單資料 */
      if (state.activeTab === 'team') {
        // 設定radio button旁的三個數字
        commit('setRecentTotal', result.recentTotal)
        commit('setNonmatchTotal', result.nonmatchTotal)
        commit('setReserveTotal', result.reserveTotal)
        // 設定列表資料
        commit('setTeamList', result.billList)
        commit('setTeamPagingTotalEntries', result.billList.length)
        let totalPages = 1
        if (state.task === 'all') {
          totalPages = result.recentTotal
        } else if (state.task === 'nonAssign') {
          totalPages = result.nonmatchTotal
        } else if (state.task === 'limitTime') {
          totalPages = result.reserveTotal
        }
        commit(
          'setTeamPagingTotalPages',
          Math.ceil(totalPages / state.teamPaging.npp),
        )
      } else if (state.activeTab === 'line') {
        commit('setLineList', result.billList)
        commit('setLinePagingTotalEntries', result.total)
        commit('setLineReserveTotal', result.total)
        commit(
          'setLinePagingTotalPages',
          Math.ceil(result.total / state.linePaging.npp),
        )
      } else if (state.activeTab === 'airport') {
        // 設定radio button旁的三個數字（與 team tab 一致）
        commit('setRecentTotal', result.recentTotal)
        commit('setNonmatchTotal', result.nonmatchTotal)
        commit('setReserveTotal', result.reserveTotal)
        // 設定列表資料
        commit('setAirportList', result.billList || [])
        commit(
          'setAirportPagingTotalEntries',
          (result.billList && result.billList.length) || 0,
        )
        // 根據 task 選擇對應的總數來計算分頁
        let totalCount = 0
        if (state.task === 'airport_recent') {
          totalCount = result.recentTotal || 0
        } else if (state.task === 'airport_unpair') {
          totalCount = result.nonmatchTotal || 0
        } else if (state.task === 'airport_hour') {
          totalCount = result.reserveTotal || 0
        }
        // 計算總頁數：如果有資料則計算頁數，否則為 1 頁（顯示空狀態）
        const calculatedPages =
          totalCount > 0 ? Math.ceil(totalCount / state.airportPaging.npp) : 1
        commit('setAirportPagingTotalPages', calculatedPages)
      } else {
        throw 'state.activeTab只能是team、line或airport三種選項'
      }
    } catch (e) {
      console.error(e)
    } finally {
      /* loading.close() */
    }
  },
  /* 取得訂單詳細資料 */
  async fetchOrderDetail({ state, commit }) {
    /* console.log('reservation id', state.modalId) */
    try {
      const { result } = await reqOrderDetail(state.modalId)
      /* console.log("modal中的訂單詳細資料", result) */
      commit('setModalDetail', result)
    } catch (e) {
      console.error(e)
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/reservation/actions.js